// removed by extract-text-webpack-plugin
module.exports = {"notificationBox":"NotificationTimed__notificationBox","notificationText":"NotificationTimed__notificationText","notificationButton":"NotificationTimed__notificationButton","notificationIcon":"NotificationTimed__notificationIcon"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/NotificationTimed/NotificationTimed.scss
// module id = 1792
// module chunks = 8